import { type FC } from 'react';

import { Button } from '@vakantiesnl/components/src/atoms/Button';
import { Typography } from '@vakantiesnl/components/src/atoms/Typography';
import { useBreakpoints } from '@vakantiesnl/components/src/utils/useBreakpoints';
import { type MicroCopy } from '@vakantiesnl/types';

import { useCustomStyles } from './PriceMatrix.styles';
import { SkeletonBlock } from '../../atoms/Skeleton/SkeletonBlock';

type Props = {
	microCopies: MicroCopy;
	carouselRange: number;
	durations: number[];
};

export const PriceMatrixSkeleton: FC<Props> = ({ microCopies, durations, carouselRange }) => {
	const { classes, cx } = useCustomStyles();
	const { isTabletOrIsDesktop } = useBreakpoints();

	const skeletonOffers = Array(carouselRange).fill('');

	return (
		<>
			<div className={classes.container} data-cy="accommodation-PriceMatrix">
				<div className={classes.matrixContainer}>
					<div className={classes.itemOffersContainer}>
						<div className={cx(classes.matrixColumn, classes.matrixDurationColumn)}>
							{durations.map((day, index) => (
								<Typography
									variant={isTabletOrIsDesktop ? 'linkMd' : 'linkSm'}
									as="h5"
									className={classes.matrixDuration}
									key={index}
								>
									{day} {microCopies['common.days']}
								</Typography>
							))}
						</div>
						{skeletonOffers.map((_, i) => (
							<div key={i} className={classes.matrixColumn}>
								<Typography
									variant={isTabletOrIsDesktop ? 'linkMd' : 'linkSm'}
									as="h5"
									className={classes.matrixDate}
								>
									<SkeletonBlock width="50px" height="24px" />
								</Typography>
								{durations.map((_, index) => (
									<SkeletonBlock key={index} width="100px" height="70px" />
								))}
							</div>
						))}
					</div>

					<div className={classes.swiftDepartureDates}>
						<>
							<Button leadingIcon="chevronLeft" variant="tertiary" size="small" data-cy="depart-earlier">
								<SkeletonBlock width="50px" />
							</Button>
							<Button trailingIcon="chevronRight" variant="tertiary" size="small" data-cy="depart-later">
								<SkeletonBlock width="50px" />
							</Button>
						</>
					</div>
				</div>
			</div>
		</>
	);
};
